import { render } from "./SpanSelection.vue?vue&type=template&id=f493e30e"
import script from "./SpanSelection.vue?vue&type=script&lang=js"
export * from "./SpanSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__